import {
  SET_DASHBOARD,
  DASHBOARD_SET_OUTLETS,
} from 'actions/dashboard/constants';
import createReducer from 'utils/createReducer';

const initialState = {
  gross_sales: 0,
  gross_profit: 0,
  net_sales: 0,
  total_transactions: 0,
  top_items: [],
  transactions: [],
  outlets: [],
  dailyGrossSales: [],
  weeklyGrossSales: [],
  hourlyGrossSales: [],
  categorySalesAmountByRevenue: {},
  categorySalesAmountByVolume: {},
  topItemsByCategory: {},
  tableManagementReport: {},
  hasError: false,
};

const reducer = createReducer(initialState, {
  [SET_DASHBOARD]: (draft, { payload }) =>
    Object.assign(draft, payload.dashboard),
  [DASHBOARD_SET_OUTLETS]: (draft, { payload }) => {
    draft.outlets = payload.outlets;
  },
});

// FIXME This custom reducer is needed because of the strange behaviour
// of `hasError`.
function customAndDoNotEverDoThisInTheFutureReducer(
  state = initialState,
  action
) {
  const handlingActions = [SET_DASHBOARD, DASHBOARD_SET_OUTLETS];

  // FIXME If there is something we handle, handle it
  if (handlingActions.includes(action.type)) {
    return reducer(state, action);
  }

  // Otherwise reset `hasError`
  return { ...state, hasError: false };
}

export default customAndDoNotEverDoThisInTheFutureReducer;
